import * as React from 'react';
import { cn } from '@packages/utils';

export type LabelProps = React.LabelHTMLAttributes<HTMLLabelElement>;

/** Mono uppercase field label (the `.ww-label` device). */
export const Label = React.forwardRef<HTMLLabelElement, LabelProps>(
  ({ className, ...props }, ref) => (
    <label ref={ref} className={cn('ww-label', className)} {...props} />
  ),
);
Label.displayName = 'Label';
